<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md6 lg5 xl4>
      <v-card>
        <v-toolbar dark color="blue darken-3">
                <v-toolbar-title> Access to the system </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="email" autofocus color="accent" label="Email" required></v-text-field>
                <v-text-field v-model="password" type="password" color="accent" label="Password" required></v-text-field>
            <v-flex class="red--text" v-if="errorM">
              {{ errorM }}
            </v-flex>
          </v-card-text>
          <v-card-actions class="px-3 pb-3">
            <v-flex text-lg-right>
              <v-btn @click="ingresar()" color="primary"> Ingresar </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script lang="js">
  import axios from "axios";
  export default {
    data() {
      return {
        email: "",
        password: "",
        errorM: null,
      }
    },
    methods: {
      async ingresar() {
          try {
            let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
          }
          let bodyContent = JSON.stringify({
            "email": this.email,
            "password": this.password
          })

          let reqOptions = {
            url: "usuario/login/",
            method: "POST",
            headers: headersList,
            data: bodyContent,
          }
          let response = await axios.request(reqOptions)
          // console.log(response.data)
          const { data } = response
          this.$store.dispatch("guardarToken", data.tokenReturn)
          this.$router.push({ name: "home" })
          // console.log(data)
          } catch (error) {
            // console.log(error)
            this.errorM = null
            if (error.message === 'Request failed with status code 404') {
              this.errorM = "The User doesn't exist or the password is incorrect"
            } else {
              this.errorM = "Server error"
            }
          }
      },
    },
  }
</script>
